module.exports = __webpack_public_path__ + "img/icon-input-select.27b388a5.svg";